var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-sider',{class:[
    _vm.theme,
    'sider',
    _vm.isMobile ? null : 'shadow',
    _vm.fixSiderbar ? 'ant-fixed-sidemenu' : null,
  ],attrs:{"width":"256px","collapsible":_vm.collapsible,"trigger":null},model:{value:(_vm.collapsed),callback:function ($$v) {_vm.collapsed=$$v},expression:"collapsed"}},[_c('div',{class:['logo', _vm.theme, _vm.collapsed ? 'small' : '']},[_c('router-link',{attrs:{"to":"/"}},[(!_vm.collapsed)?_c('img',{attrs:{"src":"eaton-online-logo.png","alt":_vm.systemName}}):_c('img',{attrs:{"src":"eaton-online-small-icon.png","alt":_vm.systemName}})])],1),_c('i-menu',{attrs:{"theme":_vm.theme,"collapsed":_vm.collapsed,"menuData":_vm.menuData},on:{"select":_vm.onSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }